// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"a79a4de9","2317":"1d37d571","4306":"acf3db16","9380":"a79a4de9","9899":"a79a4de9","9990":"a79a4de9"}[chunkId] + ".chunk.css";
};